// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZMVP","content":"LoadingAlert_content__3HEDp"};